import { Box, Typography } from '@mui/material';
import MuiTextFieldText from '../../../mui/MuiTextField/MuiTextFieldText/MuiTextFieldText';
import React from 'react';
import styles from './index.module.scss';
import {
	AddressFieldSet,
	AddressFieldsProps,
} from '../../../mui/AddressFieldSet';
import { TermsOfService, TermsOfServiceProps } from '../../TermsOfService';

export type YourInfoProps = {
	firstNameOne?: string;
	setFirstNameOne: React.Dispatch<React.SetStateAction<string | undefined>>;
	firstNameOneValidation?: string;
	lastNameOne?: string | null;
	setLastNameOne: React.Dispatch<React.SetStateAction<string | undefined>>;
	lastNameOneValidation?: string;
	firstNameTwo?: string | null;
	setFirstNameTwo: React.Dispatch<React.SetStateAction<string | undefined>>;
	firstNameTwoValidation?: string;
	lastNameTwo?: string | null;
	setLastNameTwo: React.Dispatch<React.SetStateAction<string | undefined>>;
	lastNameTwoValidation?: string;
	address?: AddressFieldsProps['address'];
	setAddress: React.Dispatch<AddressFieldsProps['address']>;
	addressValidation?: AddressFieldsProps['validate'];
} & TermsOfServiceProps;

export const YourInfo: React.FC<YourInfoProps> = ( {
	firstNameOne,
	setFirstNameOne,
	firstNameOneValidation,
	lastNameOne,
	setLastNameOne,
	lastNameOneValidation,
	firstNameTwo,
	setFirstNameTwo,
	firstNameTwoValidation,
	lastNameTwo,
	setLastNameTwo,
	lastNameTwoValidation,
	termsOfServiceAccepted,
	setTermsOfServiceAccepted,
	termsOfServiceAcceptedValidation,
	consentedToAgeAndMarketingEmails,
	setConsentedToAgeAndMarketingEmails,
	consentedToAgeAndMarketingEmailsValidation,
	onBlur: onValidate,
	address,
	setAddress,
	addressValidation,
} ) => (
	<>
		<Typography variant='h1' component='h1'>
			Nice to meet you!
		</Typography>
		<Box className={ styles.form }>
			<Box className={ styles.row }>
				<MuiTextFieldText
					label='First name'
					value={ firstNameOne || '' }
					errorText={ firstNameOneValidation }
					onChange={ ( e ) => setFirstNameOne( e.target.value ) }
					autoComplete='given-name'
					variant='standard'
					onBlur={ onValidate }
					slotProps={ {
						htmlInput: { 'data-cy': 'firstNameOne' },
					} }
					autoFocus
				/>
				<MuiTextFieldText
					label='Last name'
					value={ lastNameOne || '' }
					errorText={ lastNameOneValidation }
					onChange={ ( e ) => setLastNameOne( e.target.value ) }
					autoComplete='family-name'
					variant='standard'
					onBlur={ onValidate }
					slotProps={ {
						htmlInput: { 'data-cy': 'lastNameOne' },
					} }
				/>
			</Box>
			<Box className={ styles.row }>
				<MuiTextFieldText
					label='Second first name'
					value={ firstNameTwo || '' }
					errorText={ firstNameTwoValidation }
					onChange={ ( e ) => setFirstNameTwo( e.target.value ) }
					variant='standard'
					onBlur={ onValidate }
					slotProps={ {
						htmlInput: { 'data-cy': 'firstNameTwo' },
					} }
				/>
				<MuiTextFieldText
					label='Second last name'
					value={ lastNameTwo || '' }
					errorText={ lastNameTwoValidation }
					onChange={ ( e ) => setLastNameTwo( e.target.value ) }
					autoComplete='family-name'
					variant='standard'
					onBlur={ onValidate }
					slotProps={ {
						htmlInput: { 'data-cy': 'lastNameTwo' },
					} }
				/>
			</Box>
			<AddressFieldSet
				address={ address || {} }
				onChange={ ( values ) => setAddress( values ) }
				validate={ addressValidation }
				onBlur={ onValidate }
			/>
			<TermsOfService
				termsOfServiceAccepted={ termsOfServiceAccepted }
				setTermsOfServiceAccepted={ setTermsOfServiceAccepted }
				termsOfServiceAcceptedValidation={ termsOfServiceAcceptedValidation }
				consentedToAgeAndMarketingEmails={ consentedToAgeAndMarketingEmails }
				setConsentedToAgeAndMarketingEmails={
					setConsentedToAgeAndMarketingEmails
				}
				consentedToAgeAndMarketingEmailsValidation={
					consentedToAgeAndMarketingEmailsValidation
				}
				onBlur={ onValidate }
			/>
		</Box>
	</>
);
